/* eslint-disable */
import Persister from '../../../utils/LocalStoragePersister';

const mutations = {
    /* Connexion part */
  setEmployeeList(state, value) {
  	state.employeeList = value;
  }
};

export default mutations;
